export default __webpack_public_path__ + "images/lock-unlock-scard-ico.svg";